var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconawesomeKey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-key",
    "data-name": "Icon awesome-key",
    d: "M18,6.188a6.191,6.191,0,0,1-7.342,6.08l-.844.95a.844.844,0,0,1-.631.283H7.875v1.406a.844.844,0,0,1-.844.844H5.625v1.406A.844.844,0,0,1,4.781,18H.844A.844.844,0,0,1,0,17.156V14.412a.844.844,0,0,1,.247-.6L5.935,8.127A6.188,6.188,0,1,1,18,6.188ZM11.813,4.5A1.688,1.688,0,1,0,13.5,2.813,1.687,1.687,0,0,0,11.813,4.5Z",
    opacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconawesomeKey);
export default __webpack_public_path__ + "static/media/Icon awesome-key.ce7bead3020a6059376b71ce3e149fa8.svg";
export { ForwardRef as ReactComponent };